import {isEmpty} from 'lodash';
import {
  sendLegacyInflowPathLog,
  sendLiveThumbnailClickLog,
  sendMyAvatarClickLog,
} from '@/utils/main/my/log';

const useProfileClickLog = (isLive, broadInfo) => {
  const sendProfileClickLog = () => {
    sendMyAvatarClickLog(isLive);

    if (isLive && !isEmpty(broadInfo?.[0])) {
      const {
        broadCateNo,
        categoryTags,
        hashTags,
        broadNo,
        broadBps,
        broadResolution,
        userId,
      } = broadInfo[0];

      // 라이브 방송 클릭 로그 전송
      sendLiveThumbnailClickLog({
        streamerId: userId,
        broadcastId: broadNo,
        broadCateNo,
        broadBps,
        broadResolution,
      });

      // 기존 라이브 유입 로그 전송
      sendLegacyInflowPathLog({
        broadcastId: broadNo,
        streamerId: userId,
        isLogSendData: {
          path1: 'my',
          path2: 'top_list',
          path3: 'live',
          contentsType: 'live',
          broadCateNo: broadNo,
          categoryTag: categoryTags,
          tag: hashTags,
        },
      });
    }
  };

  return {sendProfileClickLog};
};

export default useProfileClickLog;
